import giftClient from "../../../api/gift";
import useEditorQuery from "../../../hooks/useEditorQuery";

type UseGiftQueryParams = {
  clockId?: string;
  clockIdf?: string;
  orderName?: string;
};

const useGiftQuery = (params: UseGiftQueryParams) => {
  const queryKey = params.clockId
    ? ["gift", "clockId", params.clockId]
    : params.clockIdf
      ? ["gift", "clockIdf", params.clockIdf]
      : params.orderName
        ? ["gift", "orderName", params.orderName]
        : ["gift"];

  const enabled = !!(params.clockId || params.clockIdf || params.orderName);

  return useEditorQuery({
    queryKey,
    queryFn: async () => giftClient.getGift(params),
    enabled,
  });
};

export default useGiftQuery;
